import React from 'react';
import { Navigate } from 'react-router-dom';
import { withSentryRouting } from '@sentry/react';

const ProtectedSentryRoute = withSentryRouting(({ element, visible, redirect }) => {
  if (visible === undefined || visible === null) {
    return null;
  }

  return visible ? element : <Navigate to={`/${redirect}`} replace />;
});




export default ProtectedSentryRoute;
